import { Button, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel, Radio, RadioGroup, TextField, Typography } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import NoSsr from "@material-ui/core/NoSsr";
import { withStyles } from "@material-ui/core/styles";
import { emphasize } from "@material-ui/core/styles/colorManipulator";
import classnames from "classnames";
import React, { Component } from "react";
import { Redirect } from "react-router";
import { withRouter } from "react-router-dom";
import Select from "react-select";
import { rawsuggestions } from "./Branchlist";
import ModalButtons from "./ModalButtons";
import { PrivacyStatementText } from "./PrivacyStatement";
import { TermsOfUseText } from "./TermsOfUse";


const suggestions = rawsuggestions.map(rawsuggestion => ({
  value: rawsuggestion.branchcode,
  label: rawsuggestion.label
}));

function NoOptionsMessage(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

function Control(props) {
  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          ref: props.innerRef,
          children: props.children,
          ...props.innerProps
        }
      }}
    />
  );
}

function Option(props) {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

function Placeholder(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function SingleValue(props) {
  return (
    <Typography
      className={props.selectProps.classes.singleValue}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}


const components = {
  Option,
  Control,
  NoOptionsMessage,
  Placeholder,
  SingleValue
};

const styles = theme => ({
  paperPadding: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16
  }),
  spacer: {
    marginTop: "15px",
    marginBottom: "15px"
  },

  textField: {
    width: "100%"
  },
  checkBox: {
    marginRight: "1px"
  },
  buttonStyling: {
    textTransform: "inherit",
    fontWeight: "unset",
    padding: "0",
    lineHeight: "unset",
    textDecoration: "underline",
    display: "contents"
  },

  root: {
    flexGrow: 1,
    height: 80
  },
  chip: {
    margin: theme.spacing(1 / 4)
  },
  dropdownError: {
    marginTop: "0",
    minHeight: "0",
    "&$error": {
      marginTop: "8px",
      minHeight: "1rem"
    }
  },
  error: {},
  input: {
    display: "flex",
    padding: 0,
    marginTop: theme.spacing(1)
  },
  valueContainer: {
    display: "flex",
    flex: 1,
    alignItems: "center"
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === "light"
        ? theme.palette.grey[300]
        : theme.palette.grey[700],
      0.08
    )
  },
  noOptionsMessage: {
    fontSize: 16,
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`
  },
  singleValue: {
    fontSize: 16
  },
  placeholder: {
    position: "absolute",
    left: 0,
    fontSize: 16
  },
  autoCompleteStyle: {
    "& div:before": {
      borderBottom: "2px solid #f44336"
    }
  },
  groupControl: {
    marginTop: theme.spacing(1),
    display: "block"
  },
  group: {
    margin: `${theme.spacing(1)}px 0`,
    flexDirection: "row",
    display: "inline-flex",
    left: 20,
    top: 6,
    position: "relative"
  },
  formControl: {
    width: "100%",
    marginTop: theme.spacing(1)
  }
});

class Form extends Component {
  state = {
    name: "",
    nameError: false,
    contactNumber: "",
    contactNumberError: false,
    preferredStore: "",
    preferredStoreError: false,
    value: "AM",
    isExistingCustomer: "No",
    fastTrack: "Yes",
    submitMessage: "",
    checked: false,
    checkedError: "",
    open: false,
    openSecondDialog: false,
    openPrivacyDialog: false,
    openTermsDialog: false,
    branchCode: null,
    branchAddr: null,
    thankyoualert: false,
    erroralert: false,
    btnDisabled: false,
    depositAccounts: false,
    autoLoan: false,
    homeLoan: false,
    personalLoan: false,
    creditCard: false,
    insurance: false,
    debitCard: false,
    prepaidCard: false,
    redirect: false
  };

  findAddress(inval) {
    if (inval === null) {
      return null;
    }

    var branddata = rawsuggestions.find(function(suggestion) {
      return suggestion.branchcode === inval;
    });

    if (branddata !== undefined) {
      return branddata.address;
    } else {
      return null;
    }
  }

  handleSelectChange = name => value => {
    this.setState({
      [name]: value,
      branchAddr: this.findAddress(value.value)
    });
  };

  change = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  handleRadioChange = event => {
    this.setState({ value: event.target.value });
  };

  handleIsExistingCustomer = event => {
    // console.log(event);
    this.setState({ isExistingCustomer: event.target.value });
  };

  handleCheckBox = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleOpenPrivacy = () => {
    this.setState({ openPrivacyDialog: true });
  };
  handleOpenTerms = () => {
    this.setState({ openTermsDialog: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleClose2 = () => {
    this.setState({ openSecondDialog: false });
  };
  handleThankYouClose = () => {
    this.setState({ thankyoualert: false });
  };

  handleErrorClose = () => {
    this.setState({ erroralert: false });
  };

  handleClosePrivacy = () => {
    this.setState({ openPrivacyDialog: false });
  };

  handleCloseTerms = () => {
    this.setState({ openTermsDialog: false });
  };

  handleCheckChange = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  validate = () => {
    let isError = false;
    const errors = {
      nameError: "",
      contactNumberError: "",
      preferredStoreError: "",
      checkedError: ""
    };
    if (this.state.name.length < 3) {
      isError = true;
      errors.nameError = "Name should be atleast 3 characters long";
    }
    if (this.state.contactNumber.length !== 11) {
      isError = true;
      errors.contactNumberError =
        "Mobile Number should follow the format (09XXXXXXXXX)";
    }
    if (this.state.checked === false) {
      isError = true;
      errors.checkedError =
        "You can only submit this form if you agree to our privacy statement and terms of use";
    }
    if (this.state.branchCode === null) {
      isError = true;
      errors.preferredStoreError = "Please select a Preferred Store.";
    }

    if (isError) {
      this.setState(errors);
    }
    return isError;
  };

  onContinue = e => {
    e.preventDefault();
    const err = this.validate();
    if (!err) {
      this.props.history.push("/application-form");
    }
  };

  onSubmit = e => {
    e.preventDefault();
    const err = this.validate();
    if (!err) {
      // Tribal MOCK server code (must removed or replaced by EW tech)

      //Disable Button to prevent multiple send
      this.setState({ btnDisabled: true });

      //From others data
      let othersData = [];
      var othersDataStr;

      if (this.state.depositAccounts) {
        othersData.push("deposit");
      }

      if (this.state.autoLoan) {
        othersData.push("auto loan");
      }

      if (this.state.homeLoan) {
        othersData.push("home loan");
      }

      if (this.state.personalLoan) {
        othersData.push("personal loan");
      }

      if (this.state.creditCard) {
        othersData.push("credit cards");
      }

      if (this.state.insurance) {
        othersData.push("insurance");
      }

      if (this.state.isExistingCustomer === "No") {
        othersDataStr = othersData.join(",") + "|no";
      } else {
        othersDataStr = othersData.join(",") + "|yes";
      }

      fetch("https://www.eastwestbanker.com/ServiceGateway/api/transaction/process?CustomerName=" + this.state.name +
        "&MobileNumber=" + this.state.contactNumber +
        "&PreferredStore=" + this.state.branchCode.value +
        "&PreferredSchedule=" + this.state.value +
        "&AgreeTerms=Yes&Others=DepositAccounts:" + this.state.depositAccounts +
        ",Auto Loan:" + this.state.autoLoan +
        ",Home Loan:" + this.state.homeLoan +
        ",Personal Loan:" + this.state.personalLoan +
        ",Credit Card:" + this.state.creditCard + "|" + this.state.isExistingCustomer,
        {
          method: 'GET',
          body: null,

        }
      ).then(response => {
          if (response.ok) {
            this.setState({
              name: "",
              nameError: "",
              contactNumber: "",
              contactNumberError: "",
              preferredStoreError: "",
              value: "AM",
              submitMessage: "Your details were sent successfully!",
              checkedError: "",
              branchCode: null,
              branchAddr: null,
              checked: false,
              thankyoualert: true,
              btnDisabled: false,
              redirect: true
            });
            this.props.handleClose();
            window.dataLayer.push({
              ewformeventcat: "EW Homepage Form Submit",
              ewformeventaction: "Details successfully saved!",
              event: "ewformevent"
            });
          } else {
            this.setState({
              erroralert: true,
              btnDisabled: false
            });
            window.dataLayer.push({
              ewformeventcat: "EW Homepage Form Submit",
              ewformeventaction: "API Error!!!",
              event: "ewformevent"
            });
          }
        })
        .catch(err => {
          console.log(err);
          this.setState({
            erroralert: true,
            btnDisabled: false
          });
        });

      // EW API backend integration here (To be Added by EW developer since we were not given access to the API)
    }

  };

  render() {
    if (this.state.redirect) {
      return <Redirect to="/callback/thankyou" />
    }
    const { classes } = this.props;
    const { fullScreen } = this.props;
    return (
      <div className="gridContainer">
        <Grid
          container
          className={classnames(classes.spacer, classes.paperPadding)}
        >
          <Typography variant="body1">
            Find out how our products and services can bring you closer to
            achieving your goals. Share your contact details and let’s talk.
          </Typography>
          <Typography variant="body1">
            {this.state.submitMessage}
          </Typography>
          <form>
              <TextField
                required
                color="secondary"
                id="name"
                name="name"
                label="Name"
                className={classes.textField}
                value={this.state.name}
                onChange={e => this.change(e)}
                error={this.state.nameError}
                helperText={this.state.nameError}
                margin="normal"
              />

              <br />
              <TextField
                required
                color="secondary"
                id="contactNumber"
                name="contactNumber"
                label="Mobile Number"
                type="number"
                placeholder="09XXXXXXXXX"
                className={classes.textField}
                value={this.state.contactNumber}
                onChange={e => this.change(e)}
                error={this.state.contactNumberError}
                helperText={this.state.contactNumberError}
                margin="normal"
              />
              <br />
              <br />
              <FormControl
                component="fieldset"
                required
                className={classes.formControl}
              >
                <FormLabel component="legend">
                  Preferred time to contact you
                </FormLabel>
                <RadioGroup
                  aria-label="Time"
                  name="Time"
                  id="preferredTime"
                  className={classes.group}
                  value={this.state.value}
                  onChange={this.handleRadioChange}
                >
                  <FormControlLabel
                    className="formRadioTextColor"
                    value="AM"
                    control={<Radio color="primary" />}
                    label="AM"
                  />
                  <FormControlLabel
                    className="formRadioTextColor"
                    value="PM"
                    control={<Radio color="primary" />}
                    label="PM"
                  />
                </RadioGroup>
              </FormControl>
              <br />

              <FormControl
                className={classes.formControl}
                error={this.state.preferredStoreError !== false ? true : false}
              >
                <NoSsr>
                  <Select
                    styles={{ border: "1px solid black" }}
                    className={
                      this.state.preferredStoreError !== false
                        ? classes.autoCompleteStyle
                        : ""
                    }
                    classes={classes}
                    options={suggestions}
                    components={components}
                    value={this.state.branchCode}
                    onChange={this.handleSelectChange("branchCode")}
                    placeholder={
                      this.state.preferredStoreError !== false ? (
                        <span style={{ color: "#f44336" }}>
                          {" "}
                          Please select a Preferred Store.
                        </span>
                      ) : (
                        "Please select a Preferred Store."
                      )
                    }
                  />
                </NoSsr>
                <Typography component="p">{this.state.branchAddr}</Typography>
                <FormHelperText
                  classes={{
                    root: classes.dropdownError,
                    error: classes.error
                  }}
                  component="span"
                >
                  {this.state.preferredStoreError}
                </FormHelperText>
              </FormControl>
              <br />
              <br />
              <FormControl component="fieldset">
                <FormLabel component="legend">
                  What products are you interested in?
                </FormLabel>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.depositAccounts}
                        onChange={this.handleCheckChange("depositAccounts")}
                        value="Deposit Accounts"
                        color="primary"
                      />
                    }
                    label="Deposit Accounts"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.autoLoan}
                        onChange={this.handleCheckChange("autoLoan")}
                        value="Auto Loan"
                        color="primary"
                      />
                    }
                    label="Auto Loan"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.homeLoan}
                        onChange={this.handleCheckChange("homeLoan")}
                        value="Home Loan"
                        color="primary"
                      />
                    }
                    label="Home Loan"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.personalLoan}
                        onChange={this.handleCheckChange("personalLoan")}
                        value="Personal Loan"
                        color="primary"
                      />
                    }
                    label="Personal Loan"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.creditCard}
                        onChange={this.handleCheckChange("creditCard")}
                        value="Credit Card"
                        color="primary"
                      />
                    }
                    label="Credit Card"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.insurance}
                        onChange={this.handleCheckChange("insurance")}
                        value="Insurance"
                        color="primary"
                      />
                    }
                    label="Insurance"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.debitCard}
                        onChange={this.handleCheckChange("debitCard")}
                        value="Debit Card"
                        color="primary"
                      />
                    }
                    label="Debit Card"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.prepaidCard}
                        onChange={this.handleCheckChange("prepaidCard")}
                        value="Prepaid card"
                        color="primary"
                      />
                    }
                    label="Prepaid card"
                  />
                </FormGroup>
              </FormControl>

              <br />
              <br />

              <FormControl
                component="fieldset"
                required
                className={classes.formControl}
              >
                <FormLabel component="legend">
                  Do you have an existing account with EastWest Bank?
                </FormLabel>
                <RadioGroup
                  aria-label="Time"
                  name="isExistingCustomer"
                  id="isExistingCustomer"
                  className={classes.group}
                  value={this.state.isExistingCustomer}
                  onChange={this.handleIsExistingCustomer}
                >
                  <FormControlLabel
                    className="formRadioTextColor"
                    value="Yes"
                    control={<Radio color="primary" />}
                    label="Yes"
                  />
                  <FormControlLabel
                    className="formRadioTextColor"
                    value="No"
                    control={<Radio color="primary" />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>


              <article style={{ display: "flex" }}>
                <FormControlLabel
                  className={classes.checkBox}
                  control={
                    <Checkbox
                      checked={this.state.checked}
                      onChange={this.handleCheckBox("checked")}
                      value="checked"
                      color="primary"
                    />
                  }
                />
                <div style={{ display: "flex" }}>
                  <Typography
                    style={{ alignSelf: "center" }}
                    variant="body1"

                  >
                    I agree to the{" "}
                    <u>
                      <ModalButtons
                        header="Privacy Policy"
                        dialogBody={<PrivacyStatementText />}
                        buttonTitle="Privacy Statement"
                      />
                    </u>{" "}
                    and{" "}
                    <u>
                      <ModalButtons
                        header="Terms of Use"
                        dialogBody={<TermsOfUseText />}
                        buttonTitle="Terms of Use"
                      />
                    </u>
                  </Typography>
                </div>
              </article>
            <Typography style={{ color: "red" }} variant="caption">
              {this.state.checkedError}
            </Typography>
            <br />
            <div style={{ textAlign: "center" }}>
              <Button
                id="submit-homepage"
                className="trackme"
                disabled={this.state.btnDisabled}
                variant="contained"
                color="secondary"
                size="large"
                onClick={e => this.onSubmit(e)}
              >
                Submit
              </Button>
            </div>
          </form>

          <Dialog
            open={this.state.thankyoualert}
            onClose={this.handleThankYouClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Thank you"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Your details were sent successfully!
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleThankYouClose} color="secondary">
                OK
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={this.state.erroralert}
            onClose={this.handleErrorClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Error"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                An error was encountered while trying to save your data.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleErrorClose} color="secondary">
                OK
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            fullScreen={fullScreen}
            open={this.state.openPrivacyDialog}
            onClose={this.handlePrivacy}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogContent>
              <PrivacyStatementText />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClosePrivacy} color="secondary">
                Close
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            fullScreen={fullScreen}
            open={this.state.openTermsDialog}
            onClose={this.handleCloseTerms}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogContent>
              <TermsOfUseText />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleCloseTerms} color="secondary">
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </Grid>
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(Form));
